export const COMPANY_DATA = {
  Meta: '/images/companies/meta.png',
  Google: '/images/companies/google.png',
  Microsoft: '/images/companies/microsoft.png',
  Amazon: '/images/companies/amazon.png',
  OpenAI: '/images/companies/openai.png',
  NVIDIA: '/images/companies/nvidia.png',
  Airbnb: '/images/companies/airbnb.png',
  TikTok: '/images/companies/tiktok.png',
  Stripe: '/images/companies/stripe.png',
  Facebook: '/images/companies/meta.png',
  Linkedin: '/images/companies/linkedin.png',
  Uber: '/images/companies/uber.webp',
  Spotify: '/images/companies/spotify.png',
  Doordash: '/images/companies/doordash.png',
  Apple: '/images/companies/apple.png',
  'Google-cloud': 'https://exponent-static.s3.amazonaws.com/company_logos/google.png',
  Netflix: 'https://exponent-static.s3.amazonaws.com/company_logos/netflix.png',
  Adobe: 'https://exponent-static.s3.amazonaws.com/company_logos/adobe.png',
  Lyft: 'https://exponent-static.s3.amazonaws.com/company_logos/lyft.png',
  Walmart: 'https://exponent-static.s3.amazonaws.com/company_logos/walmart.png',
  Tesla: 'https://exponent-static.s3.amazonaws.com/company_logos/tesla.png',
  Salesforce: 'https://exponent-static.s3.amazonaws.com/company_logos/salesforce.png',
  Coinbase: 'https://exponent-static.s3.amazonaws.com/company_logos/coinbase.png',
  Discord: 'https://exponent-static.s3.amazonaws.com/company_logos/discord.png',
};

export const FALLBACK_COMPANY_IDS = ['Meta', 'Google', 'Microsoft', 'Amazon', 'OpenAI', 'Airbnb', 'TikTok', 'Stripe'];

// Output by scripts/generate_top_companies_by_course.js
export const TOP_COMPANIES_BY_CONTENT = {
  algorithms: [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'amazon-leadership-principles': [
    'Amazon',
    'Google',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'amazon-pm-overview': [
    'Amazon',
    'Google',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  analytical: [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'analytical-problem-solving': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Doordash',
    'Linkedin',
  ],
  'app-critique': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  arrays: [
    'Apple',
    'Microsoft',
    'Linkedin',
    'Facebook',
    'Google',
    'Amazon',
    'Google-cloud',
    'Netflix',
  ],
  'aws-sa-intro': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  behavioral: [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'behavioral-bizops': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'behavioral-interviews-for-pms': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'bizops-data': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Apple',
    'Doordash',
  ],
  'bizops-intro': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'break-into-fintech': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'common-pmm': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Spotify',
    'Uber',
    'Doordash',
  ],
  'conduct-uer': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'cross-functional-pmm': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'cross-functional-tpm': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'data-analyst-introduction': [
    'Facebook',
    'Google',
    'Amazon',
    'Uber',
    'Doordash',
    'Microsoft',
    'Adobe',
    'Apple',
  ],
  'data-analyst-technical': [
    'Google',
    'Amazon',
    'Facebook',
    'Doordash',
    'Microsoft',
  ],
  'data-analytics-behavioral': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Doordash',
    'Apple',
    'Uber',
    'Stripe',
  ],
  'data-analytics-introduction': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Apple',
    'Uber',
    'Doordash',
    'Linkedin',
  ],
  'data-analytics-take-home-case-studies': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Uber',
    'Apple',
    'Doordash',
    'Spotify',
  ],
  'data-analytics-technical': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Apple',
    'Uber',
    'Doordash',
    'Stripe',
  ],
  'data-communications-questions': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-engineering-intro': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-engineer-sql-review-test': [
    'Google',
    'Microsoft',
    'Facebook',
    'Apple',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
  ],
  'data-modeling-interviews': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-pipeline-design-interviews': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-science': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-science-interview-practice': [
    'Google',
    'Facebook',
    'Amazon',
    'Linkedin',
    'Microsoft',
    'Doordash',
    'Apple',
    'Uber',
  ],
  'data-scientist-introduction': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-structures': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'design-challenges': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'design-run-experiments': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'dynamic-programming': [
    'Google',
    'Facebook',
    'Linkedin',
    'Amazon',
    'Uber',
    'Microsoft',
    'Netflix',
    'Stripe',
  ],
  'em-intro': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  estimation: [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  execution: [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'facebook-pm-overview': [
    'Facebook',
    'Google',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'favorite-product': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'fundamentals-analytics': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'fundamentals-system-design': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  gamestop: [
    'Google',
    'Amazon',
    'Uber',
    'Facebook',
    'Linkedin',
    'Microsoft',
    'Spotify',
    'Lyft',
  ],
  'general-interview': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'get-the-interview': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'google-collaboration': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'google-craft-execution': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'google-pm-overview': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'graphs-and-trees': [
    'Google',
    'Microsoft',
    'Amazon',
    'Facebook',
    'Uber',
    'Linkedin',
    'Spotify',
    'Apple',
  ],
  'hash-tables': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Apple',
    'Doordash',
  ],
  heaps: [
    'Google',
    'Amazon',
    'Apple',
    'Linkedin',
    'Walmart-labs',
  ],
  'introduction-to-security-engineering': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
    'Uber',
    'Stripe',
  ],
  'machine-learning': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'marketing-case': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'marketing-strategy': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'ml-coding': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Linkedin',
    'Uber',
    'Doordash',
  ],
  'ml-coding-data-scientist-questions': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'ml-concepts-interviews': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'ml-concepts-questions': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Google-cloud',
  ],
  'ml-concepts-questions-data-scientists': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'ml-engineer-intro': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'ml-system-design': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'ml-system-design-questions': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Linkedin',
    'Uber',
    'Google-cloud',
  ],
  'people-management': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  pm: [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'pm-intro': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  pmm: [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Spotify',
    'Uber',
    'Doordash',
  ],
  'pm-product-design': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'pm-skills': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'pm-technical': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'portfolio-review': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Spotify',
    'Uber',
    'Apple',
  ],
  'preview-system-design-questions': [
    'Facebook',
    'Amazon',
    'Doordash',
    'Google',
    'Microsoft',
  ],
  'product-designer-intro': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'product-sense-case-studies-questions': [
    'Facebook',
    'Google',
    'Amazon',
    'Apple',
    'Microsoft',
    'Uber',
    'Doordash',
    'Stripe',
  ],
  'product-strategy': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'program-sense': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'project-mgmt-bizops': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'project-retro': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Doordash',
    'Spotify',
  ],
  'python-array-practice': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Apple',
    'Linkedin',
    'Uber',
    'Stripe',
  ],
  'python-coding-data-scientist-questions': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'python-data-and-machine-learning': [
    'Facebook',
    'Google',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Stripe',
  ],
  'python-graphs-and-trees-practice': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
    'Uber',
    'Stripe',
  ],
  'python-linked-list-practice': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Linkedin',
    'Uber',
    'Netflix',
  ],
  'python-ml-system-design': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Apple',
    'Linkedin',
    'Uber',
    'Stripe',
  ],
  'python-string-practice': [
    'Facebook',
    'Google',
    'Microsoft',
    'Stripe',
    'Apple',
    'Linkedin',
    'Amazon',
    'Spotify',
  ],
  'recursion-and-backtracking': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Apple',
    'Linkedin',
    'Uber',
    'Doordash',
  ],
  'sa-customer-interaction': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'sa-intro': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'sa-technical': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'searching-and-sorting': [
    'Google',
    'Microsoft',
    'Apple',
    'Amazon',
    'Linkedin',
    'Facebook',
    'Google-cloud',
    'Spotify',
  ],
  'security-engineering-mock-interviews': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Apple',
    'Uber',
    'Spotify',
  ],
  'security-principles': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
    'Uber',
    'Doordash',
  ],
  'software-engineering': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'solutions-architect-behavioral': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'sql-foundations': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'sql-interview-questions': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'sql-interviews': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'sql-practice-questions': [
    'Facebook',
    'Google',
    'Microsoft',
    'Amazon',
    'Apple',
    'Linkedin',
    'Uber',
    'Doordash',
  ],
  'stacks-and-queues': [
    'Google',
    'Lyft',
    'Apple',
    'Facebook',
    'Linkedin',
    'Microsoft',
    'Spotify',
    'Stripe',
  ],
  'stakeholder-management-bizops': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'statistics-experimentation-questions': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'strategic-decisions-bizops': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'string-manipulation': [
    'Google',
    'Apple',
    'Microsoft',
    'Linkedin',
    'Spotify',
    'Google-cloud',
    'Facebook',
    'Lyft',
  ],
  'swe-behavioral': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Apple',
    'Doordash',
  ],
  'swe-intro': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'swe-practice': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Uber',
    'Linkedin',
    'Apple',
    'Doordash',
  ],
  'system-design': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'system-design-interviews': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Stripe',
  ],
  'take-home': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'technical-basics-pm': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'tech-salary-offer-negotiation': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Apple',
    'Uber',
    'Stripe',
  ],
  tpm: [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'tpm-intro': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  undefined: [
    'Google',
    'Microsoft',
    'Facebook',
    'Amazon',
    'Uber',
    'Linkedin',
    'Spotify',
    'Apple',
  ],
  'user-insight': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'amazon-interview': [
    'Amazon',
    'Google',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'amazon-sde-interview': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Uber',
    'Linkedin',
    'Apple',
    'Doordash',
  ],
  'amazon-sdm-interview': [
    'Amazon',
    'Google',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Doordash',
    'Spotify',
  ],
  'amazon-solution-architect-interview': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  bizops: [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'data-analyst': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Doordash',
    'Uber',
    'Adobe',
    'Apple',
  ],
  'data-analytics': [
    'Google',
    'Amazon',
    'Facebook',
    'Microsoft',
    'Apple',
    'Uber',
    'Doordash',
    'Linkedin',
  ],
  'data-engineering': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'data-science-interview': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'data-scientist': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Apple',
    'Walmart-labs',
    'Airbnb',
  ],
  'engineering-management': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'facebook-pm-interview': [
    'Facebook',
    'Google',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'google-pm-interview': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
  'ml-engineer': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
    'Linkedin',
    'Doordash',
  ],
  'product-designer-interview': [
    'Google',
    'Facebook',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
    'Spotify',
    'Apple',
  ],
  'python-developer-interviews': [
    'Amazon',
    'Facebook',
    'Google',
    'Microsoft',
    'Apple',
    'Linkedin',
    'Tiktok',
    'Salesforce',
  ],
  'python-developer-interviews-test': [
    'Google',
    'Apple',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Amazon',
    'Coinbase',
    'Google-cloud',
  ],
  'security-engineering-interviews': [
    'Google',
    'Amazon',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
    'Uber',
    'Stripe',
  ],
  'solution-architect-interview': [
    'Amazon',
    'Google',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
    'Apple',
    'Spotify',
  ],
  'system-design-interview': [
    'Google',
    'Facebook',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
    'Spotify',
    'Doordash',
  ],
};
